module.exports = __webpack_public_path__ + "img/ep-croix-2.68df7ae4.jpg";